export default "__VITE_ASSET__vQLCF2aH__"